import { Video } from "@/types/videos";
import { resolvePlaybackUrls } from "@/services/playbackUrls";

type FeedItem = Video | { id: string; isAd: true };

/** Fenêtre de signature autour de la vidéo courante (avant / après). */
const BEHIND = 2;
const AHEAD = 5;

/**
 * Signe en UN SEUL appel toutes les URLs de lecture de la fenêtre courante.
 *
 * Pourquoi : signer au moment où une vidéo devient active place l'appel réseau
 * APRÈS le geste (signature → manifeste → premier fragment → première image).
 * En préparant la fenêtre à l'avance, l'URL est déjà en cache au moment du
 * swipe : il ne reste plus rien à demander au serveur.
 *
 * Le cache de `playbackUrls.ts` dédoublonne déjà : rappeler cette fonction à
 * chaque changement d'index ne provoque aucune requête inutile.
 */
export function warmWindow(videos: FeedItem[], index: number): void {
  const from = Math.max(0, index - BEHIND);
  const to = Math.min(videos.length - 1, index + AHEAD);

  const ids: string[] = [];
  for (let i = from; i <= to; i += 1) {
    const item = videos[i];
    if (!item || "isAd" in item) continue;
    ids.push(item.id);
  }

  if (ids.length === 0) return;
  void resolvePlaybackUrls(ids);
}
